import { useState, useEffect } from 'react';

// Matches the `@media (min-width: 769px)` breakpoint JoinPage.module.css already uses to
// switch between the full-bleed mobile layout and the centered "phone frame" desktop layout.
const QUERY = '(min-width: 769px)';

/** True once the viewport is wide enough to not be a phone. Updates live on resize/rotate. */
export function useIsMobileViewport() {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return true;
        return !window.matchMedia(QUERY).matches;
    });

    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return;
        const mql = window.matchMedia(QUERY);
        const handler = (e) => setIsMobile(!e.matches);
        handler(mql);
        mql.addEventListener('change', handler);
        return () => mql.removeEventListener('change', handler);
    }, []);

    return isMobile;
}
